import { memo } from "react";
import PropTypes from "prop-types";
import useTranslation from "@/hooks/useTranslation";

/**
 * Inline translation component.
 *
 * - Wraps text in a <span> to prevent the Google Translate "removeChild" error.
 * - Shows reduced opacity while the translation is being fetched.
 *
 * Props:
 *   k         {string}  – translation key (from translations.js) or plain text
 *   style     {object}  – optional inline styles on the span
 *   className {string}  – optional class name
 *
 * @example
 *   <T k="nav.about" />
 *   <T k="Some arbitrary text" />   ← fetched from Google Translate
 */
const T = ({ k, style, className }) => {
    const { t, isKeyLoading } = useTranslation();
    const loading = isKeyLoading(k);

    return (
        <span
            style={{
                ...style,
                opacity: loading ? 0.4 : 1,
                transition: "opacity 0.2s",
            }}
            className={className}
        >
            {t(k)}
        </span>
    );
};

T.propTypes = {
    k: PropTypes.string.isRequired,
    style: PropTypes.object,
    className: PropTypes.string,
};

export default memo(T);
